import onlineclass from '../components/onlineClass.vue';
import errorMsg from '../components/errorMsg.vue';
import checkLang from '../components/checkLang.vue';
import chooseMode from '../components/chooseMode.vue';
const routes = [
    { path: '/', component: onlineclass },
    { path: '/errorMsg', component: errorMsg },
    { path: '/checkLang', component: checkLang },
    { path: '/chooseMode', component: chooseMode },
    { path: '/:cid/:data', component: onlineclass },
];

let mode = "";
console.log("process.env.NODE_ENV = " + process.env.NODE_ENV);

let env = process.env.NODE_ENV;
if (env === 'development') {
    mode = "history";
} else if (env === 'production') {
    mode = "history";
}

export default {
    routes: routes,
    mode: mode
};


// WEBPACK FOOTER //
// ./src/router/router.config.js